export const needLensflare = (pano) =>
  pano &&
  !pano.noLensFlare &&
  pano.lensFlareLocation &&
  typeof pano.lensFlareLocation[0] === 'number' &&
  typeof pano.lensFlareLocation[1] === 'number' &&
  typeof pano.lensFlareLocation[2] === 'number';
